import { useState } from "react";
import PersianNumber from "../../utils/PersianNumber/PersianNumber";
import { IoArrowDownOutline, IoArrowUpOutline } from "react-icons/io5";
import TransactionPage from "./TransactionPage";

const BoxUi = ({
  roleName,
  _item,
  handlePriceChange,
  handleWeightChange,
  handleTotalChange,
  addCommas,
  setProduct_name,
  setCustomeruser,
  userInfo,
  setBos,
  setIs_orderi,
  handlePostTransaction,
  handleChangeBuyPrice,
  handleChangeSellPrice,
  handleChangeBuyClosePriceProduct,
  handleChangeSellClosePriceProduct,
}) => {
  const [showTransactionPage, setShowTransactionPage] = useState(false);
  const [transactionType, setTransactionType] = useState('');
  const [statePrice, setStatePrice] = useState('');
  const [stateWeight, setStateWeight] = useState('');
  const [stateTotal, setStateTotal] = useState('');
  const [description, setDescription] = useState('');

  const handleTransactionSubmit = async () => {
    setProduct_name(_item.name);
    setCustomeruser(userInfo[0]?.id);
    setBos(transactionType === "buy" ? "B" : "S");
    setIs_orderi(
      transactionType === "buy" 
        ? _item.buy_price !== statePrice 
        : _item.sell_price !== statePrice
    );
    
    try {
      await handlePostTransaction();
      return true;
    } catch (error) {
      console.error("Error submitting transaction:", error);
      return false;
    }
  };

  const handlePriceClick = (type) => {
    setStatePrice(_item[`${type}_price`]);
    setStateWeight("");
    setStateTotal("");
    setDescription("");
    setTransactionType(type);
    setShowTransactionPage(true);
  };

  return (
    <>
      <div key={_item.id}>
        <div className="h-80 w-[18rem] rounded-xl bg-[#1a1d2783] shadow-lg relative mx-8 py-2">
          <div className="flex flex-col justify-center mt-4 relative space-y-12">
            {/* Discount */}
            <span className="absolute text-xs text-white -top-3 right-4">
              {_item.change === -1 ? (
                "-"
              ) : (
                <span
                  className={`${
                    _item.change < 0
                      ? "bg-red-500"
                      : _item.change > 0
                      ? "bg-green-500"
                      : "bg-gray-500"
                  } inline-flex items-center justify-center 
                  rounded-full px-2 py-1 text-xs font-bold 
                  leading-none text-white`}
                >
                  <PersianNumber value={_item.change} suffix={"%"} />
                </span>
              )}
            </span>

            {/* Last Update */}
            <span className="absolute text-slate-400 top-14 left-4">
              {_item.last_update_time_ago}
            </span>

            {/* Title */}
            <div className="flex justify-center items-center text-center">
              <h3 className="font-medium text-xl tracking-tight text-gray-100">
                {_item.name}
              </h3>
            </div>

            {/* Prices */}
            <div className="flex flex-col justify-center items-center mx-5">
              <div className="flex justify-center items-center p-2 w-full text-lg font-normal">
                {/* Buy Price */}
                <div className="flex flex-col items-center mx-4">
                  <div className="text-green-500 flex items-center mb-2">
                    {roleName === "ADMIN" && _item.buy_price !== -1 && (
                      <button
                        className="mr-2 text-gray-400 hover:text-green-500"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChangeBuyPrice(_item?.id, "buyIncrement", _item?.tag);
                        }}
                      >
                        <IoArrowUpOutline />
                      </button>
                    )}
                    
                    <div
                      onClick={() => handlePriceClick("buy")}
                      className="flex items-center cursor-pointer"
                    >
                      {_item.buy_price === -1 ? (
                        "-"
                      ) : (
                        <>
                          <PersianNumber value={_item.buy_price} thousandSeparator="," />
                          <span className="text-xs text-gray-400 mr-1">تومان</span>
                        </>
                      )}
                    </div>
                    
                    {roleName === "ADMIN" && _item.buy_price !== -1 && (
                      <button
                        className="ml-2 text-gray-400 hover:text-green-500"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChangeBuyPrice(_item?.id, "buyDecrement", _item?.tag);
                        }}
                      >
                        <IoArrowDownOutline />
                      </button>
                    )}
                  </div>
                  
                  {roleName === "ADMIN" && (
                    <button
                      onClick={() =>
                        handleChangeBuyClosePriceProduct(
                          _item?.id,
                          !_item?.is_buy_closed,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close
                        )
                      }
                      className={`text-xs ${
                        _item?.is_buy_closed ? "text-red-500" : "text-green-500"
                      } hover:underline`}
                    >
                      {_item?.is_buy_closed ? "قیمت خرید بسته" : "قیمت خرید باز"}
                    </button>
                  )}
                </div>

                {/* Sell Price */}
                <div className="flex flex-col items-center mx-4">
                  <div className="text-red-500 flex items-center mb-2">
                    {roleName === "ADMIN" && _item.sell_price !== -1 && (
                      <button
                        className="mr-2 text-gray-400 hover:text-red-500"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChangeSellPrice(_item?.id, "sellIncrement", _item?.tag);
                        }}
                      >
                        <IoArrowUpOutline />
                      </button>
                    )}
                    
                    <div
                      onClick={() => handlePriceClick("sell")}
                      className="flex items-center cursor-pointer"
                    >
                      {_item.sell_price === -1 ? (
                        "-"
                      ) : (
                        <>
                          <PersianNumber value={_item.sell_price} thousandSeparator="," />
                          <span className="text-xs text-gray-400 mr-1">تومان</span>
                        </>
                      )}
                    </div>
                    
                    {roleName === "ADMIN" && _item.sell_price !== -1 && (
                      <button
                        className="ml-2 text-gray-400 hover:text-red-500"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChangeSellPrice(_item?.id, "sellDecrement", _item?.tag);
                        }}
                      >
                        <IoArrowDownOutline />
                      </button>
                    )}
                  </div>
                  
                  {roleName === "ADMIN" && (
                    <button
                      onClick={() =>
                        handleChangeSellClosePriceProduct(
                          _item?.id,
                          !_item?.is_sell_closed,
                          _item?.periority,
                          _item?.is_buy_closed,
                          _item?.is_market_close
                        )
                      }
                      className={`text-xs ${
                        _item?.is_sell_closed ? "text-red-500" : "text-green-500"
                      } hover:underline`}
                    >
                      {_item?.is_sell_closed ? "قیمت فروش بسته" : "قیمت فروش باز"}
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-center">
              <button
                onClick={() => handlePriceClick("buy")}
                className="mx-3 text-white hover:bg-green-600 
                border-2 border-green-600 tracking-wider text-sm
                rounded-xl px-3 py-0.5 hover:text-white transition-all"
              >
                خرید شما
              </button>
              <button
                onClick={() => handlePriceClick("sell")}
                className="mx-3 text-white hover:bg-red-600 
                border-2 border-red-600 tracking-wider text-sm
                rounded-xl px-3 py-0.5 hover:text-white transition-all"
              >
                فروش شما
              </button>
            </div>
          </div>
        </div>
      </div>

      {showTransactionPage && (
        <TransactionPage
          item={_item}
          type={transactionType}
          onClose={() => setShowTransactionPage(false)}
          onSubmit={handleTransactionSubmit}
          statePrice={statePrice}
          setStatePrice={setStatePrice}
          stateWeight={stateWeight}
          setStateWeight={setStateWeight}
          stateTotal={stateTotal}
          setStateTotal={setStateTotal}
          description={description}
          setDescription={setDescription}
          addCommas={addCommas}
          handlePriceChange={handlePriceChange}
          handleWeightChange={handleWeightChange}
          handleTotalChange={handleTotalChange}
          roleName={roleName}
        />
      )}
    </>
  );
};

export default BoxUi;